<template>
  <div class="flex flex-wrap h-full -mx-4">
    <div class="lg:flex-1 flex flex-col px-4 my-auto">
      <slot />
      <section class="auto-rows-min grid items-center grid-cols-3 gap-2">
        <hr class="col-span-full" />
        <label class="lg:col-span-1 col-span-full"
          >Seleziona il pacchetto:</label
        >
        <div
          class="col-span-full lg:col-span-2 lg:grid-cols-2 grid grid-flow-row grid-cols-1 gap-2"
        >
          <package-selector v-model:activePack="selectedPackage" />
        </div>
        <hr class="col-span-full" />
        <section class="col-span-full">
          <div class="sm:text-left prose prose-calcolatore col-span-full">
            <p>
              Il canone è gratis per i primi 3 mesi. Dopo, puoi azzerare o
              scontare il canone accreditando stipendio/pensione. Costo base
              pacchetti Semplice: 3€ al mese scontabile fino a 0€, Semplice
              Plus: 6€ al mese scontabile fino a 3€.
            </p>
          </div>
        </section>
        <hr class="col-span-full" />
        <div
          class="col-span-full flex items-center justify-between lg:col-span-2"
        >
          <label>Giacenza media annua:</label>
          <input
            ref="giacenzamedia"
            type="text"
            maxlength="7"
            class="rounded-2xl text-center w-1/2 text-gray-500"
            @blur="afterGiacenza($event.target.value)"
            v-model.number="depositAmount"
            @keypress="onlyNumber"
          />
        </div>
        <!-- <div
          class="col-span-full lg:col-span-2 lg:grid-cols-2 grid items-center grid-flow-row grid-cols-1 gap-2"
        > -->

        <hr class="col-span-full" />

        <div
          class="lg:col-span-3 col-span-full flex items-center justify-between"
        >
          <div class="sm:text-left prose col-span-full">
            <p>
              Simulazione rendimento netto. Promo riservata ai nuovi clienti che
              aprono il conto dal 09/09/2026 al 31/12/2026 (salvo chiusura
              anticipata dell'offerta). Per i primi 3 mesi dall'apertura: canone
              gratuito. Tasso creditore annuo lordo variabile, indicizzato
              all'Euribor 3 mesi e pari al valore dell'Euribor 3 mesi diminuito
              di 1,40 punti percentuali, applicato alla giacenza libera media
              annua presente sul conto, fino a un importo massimo di 5.000.000€.
              <a
                href="https://www.iblbanca.it/-/media/project/ibl/corporate/DocumentiPDF/Controcorrente/Foglio_Informativo_ControCorrente.pdf"
                target="_blank"
                >Clicca qui per maggiori informazioni.</a
              >
            </p>
          </div>
        </div>

        <hr class="col-span-full lg:hidden mt-2" />

        <div class="col-span-full lg:hidden">
          <app-cta-button
            text="Calcola"
            class="w-full max-w-xs mx-auto uppercase"
            @click="modal = true"
          />
        </div>
        <div class="col-span-full lg:hidden">
          <p v-text="disclaimer" class="text-center" />
        </div>
        <transition name="fade">
          <app-popup-page v-if="modal" light :close="toggleModal">
            <mobile-box v-bind="profit" top
          /></app-popup-page>
        </transition>
      </section>
    </div>
    <div class="lg:w-min lg:block hidden w-full h-full px-4">
      <mobile-box v-bind="profit" :disclaimer="disclaimer" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import MobileBox from "./MobileBox.vue";
import PackageSelector from "./PackageSelector.vue";
export default {
  components: { PackageSelector, MobileBox },
  data: () => ({
    selectedPackage: Object(),
    depositAmount: 10000,
    selectedServices: [],
    profit: {},
    modal: Boolean(),
    megaPromoDate: new Date(),
    megaPromoYieldUntil: new Date()
  }),
  props: ["disclaimer"],
  async mounted() {
    try {
      const response = await this.axios.get(
        `${process.env.VUE_APP_PLUGIN_GENERAL_API}/client-settings`
      );

      this.megaPromoDate = new Date(
        response.data.data.MegaPromoRequestableUntil.slice(0, -1)
      );

      this.megaPromoDate = this.megaPromoDate.toLocaleDateString("it-IT", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      });

      this.megaPromoYieldUntil = new Date(
        response.data.data.MegaPromoYieldingUntil.slice(0, -1)
      );
    } catch (error) {
      error;
    }
  },
  computed: {
    availableServices() {
      return !_.isEmpty(this.selectedPackage)
        ? _.filter(this.selectedPackage.Discounts, i => i.PackageId)
        : [];
    },
    calcParams() {
      return {
        DepositAmount: this.depositAmount,
        TaxFeePercentage: this.taxFeePercentage,
        Services: this.selectedServices || []
      };
    },
    applicableThreshold() {
      try {
        let applicableThresholds = !_.isEmpty(this.selectedPackage)
          ? _.sortBy(this.selectedPackage.Thresholds, "ToDeposit")
          : [];
        const actualThreshold = _.head(
          _.filter(applicableThresholds, (item, ix) => {
            return ix + 1 === applicableThresholds.length
              ? this.depositAmount >= item.ToDeposit
              : this.depositAmount <= item.ToDeposit;
          })
        );
        return {
          show:
            new Date() <= this.megaPromoDate ||
            (actualThreshold.YearlyLimitedReturnPercentageMonths &&
              actualThreshold.YearlyLimitedReturnPercentage),
          campaignLabel:
            new Date() <= this.megaPromoDate
              ? "Promo interessi per i primi 6 mesi"
              : `Promo interessi primi ${actualThreshold.YearlyLimitedReturnPercentageMonths} mesi:`,
          campaignReturnPercentage: `${(
            actualThreshold.YearlyLimitedReturnPercentage || 0
          ).toLocaleString()}%`,
          returnPercentage: `${(
            actualThreshold.YearlyReturnPercentage || 0
          ).toLocaleString()}%`
        };
      } catch (error) {
        return {};
      }
    }
  },
  watch: {
    selectedPackage(newVal, oldVal) {
      this.depositAmount = newVal.DefaultDeposit;
      this.selectedServices = _.map(
        _.filter(
          this.selectedPackage.Discounts,
          i => i.DiscountId && i.DefaultServiceForCalculator
        ),
        "DiscountId"
      );
      this.calculate();
      if (!_.isEmpty(oldVal)) {
        this.$refs.giacenzamedia.scrollIntoView({
          behavior: "smooth"
        });
      }
    },
    depositAmount: _.debounce(function(newVal, oldVal) {
      if (newVal !== oldVal) {
        // console.log(`changing threshold ${this.applicableThreshold}`);

        this.calculate();
      }
    }, 500),
    selectedServices() {
      this.calculate();
    },
    calcParams: _.debounce(function(newVal, oldVal) {
      newVal !== oldVal && this.calculate();
    }, 500)
  },
  methods: {
    afterGiacenza(value) {
      this.depositAmount = _.isEmpty(value) ? 0 : value;
      //console.log(this.$refs.servizi);
      try {
        this.$refs.servizi.scrollIntoView({
          behavior: "smooth"
        });
      } catch (error) {
        error;
      }
    },
    toggleModal() {
      this.modal = !this.modal;
    },
    async calculate() {
      // console.log(this.calcParams);
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_PLUGIN_PACKAGE_API}/${this.selectedPackage.PackageId}/profit`,
          this.calcParams
        );
        this.profit = _.mapKeys(response.data.data, (v, k) => _.camelCase(k));
      } catch (error) {
        error;
      }
    },
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    }
  }
};
</script>

<style>
.prose-calcolatore {
  font-style: italic;
  font-size: 14px;
}
</style>
